import $ from 'jquery'

$(document).on('click', '.vjs-fullscreen-control', () => {
  toggleOverlayElements()
})

$(document).on('keydown', e => {
  if (
    [13, 27, 32].indexOf(e.which) === -1 ||
    $('.vjs-has-started').hasClass('vjs-fullscreen')
  ) {
    return
  }

  setTimeout(toggleOverlayElements)
})

function toggleOverlayElements() {
  const overlayTiles = $('.vjs-fullscreen-control')
    .closest('.overlay-tile')
    .siblings()
    .find('.overlay-tile')

  const closeButton = $('.close-overlay')

  if ($('.vjs-has-started').hasClass('vjs-fullscreen')) {
    overlayTiles.hide()
    closeButton.hide()
  } else {
    overlayTiles.show()
    closeButton.show()
  }
}



// WEBPACK FOOTER //
// ../src/utils/sharePlayerFullscreen.js